import { render, staticRenderFns } from "./UpdateAppointmentPopup.vue?vue&type=template&id=0f7ae256"
import script from "./UpdateAppointmentPopup.vue?vue&type=script&lang=ts"
export * from "./UpdateAppointmentPopup.vue?vue&type=script&lang=ts"
import style0 from "./UpdateAppointmentPopup.vue?vue&type=style&index=0&id=0f7ae256&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports